import { FETCH_WORKKARD_LETTER_REQUEST_SUCCESS,RESET_WORKKARD_LETTERS_REQUEST_SUCCESS,IS_SELECT_ALL_LETTER } from "../actions/actionConstants";
import { take } from 'redux-saga/effects';

const initialState = {
    skip: 0,
    take: 20,
    sortBy:1,
    rows:20,
    isSelectAll:false,
    filterOption:['all'],
    data:{
      Total : 0,
      Data:[]
    }

};

const mapLetterModel = (data) => data.map((item) => {
  return (
    {
      id: item.id,
      requesterComments: {
        message: item.requesterComments.message,
        by: {
          id: item.requesterComments.by.id,
          name: item.requesterComments.by.name
        },
        date: item.requesterComments.date
      },
      templateName: item.templateName,
      author: {
        Email: item.author.Email,
        UserId: item.author.UserId,
        IsActive: item.author.IsActive,
        LastName: item.author.LastName,
        UserName: item.author.UserName,
        FirstName: item.author.FirstName,
        MiddleName: item.author.MiddleName,
        DisplayName: item.author.DisplayName,
        ProfileImage: item.author.ProfileImage
      },
      requestedBy: {
        Email: item.requestedBy.Email,
        UserId: item.requestedBy.UserId,
        IsActive: item.requestedBy.IsActive,
        LastName: item.requestedBy.LastName,
        UserName: item.requestedBy.UserName,
        FirstName: item.requestedBy.FirstName,
        MiddleName: item.requestedBy.MiddleName,
        DisplayName: item.requestedBy.DisplayName,
        ProfileImage: item.requestedBy.ProfileImage
      },
      requestedAt: item.requestedAt,
      status: item.status,
      createdAt: item.createdAt,
      letterUrl: {
        FileGuid: item.letterUrl.guid,
        Caption: item.letterUrl.caption,
        FileUrl: item.letterUrl.file_url,
        FileName: item.letterUrl.file_name,
        FileType : item.letterUrl.file_type,
        FileSize : item.letterUrl.file_size
      }
    }
  )
});


export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_WORKKARD_LETTER_REQUEST_SUCCESS: {
      const completeLetterData = action.payload.data.Data.filter((item)=> item.status == 'complete' || item.status=='mailed');
      const mappedLetterData = mapLetterModel(completeLetterData)
      const workkardLettersdata =  {
            skip: action.payload.skip,
            take: action.payload.take,
            sortBy: action.payload.sortBy,
            rows: action.payload.rows,
            filterOption: action.payload.filterOption,
            data: {
              Total : mappedLetterData.length,
              Data : [...state.data.Data,...mappedLetterData]
            }
      }
      return Object.assign (
            {},
            state,
            workkardLettersdata
      )
    }

    case RESET_WORKKARD_LETTERS_REQUEST_SUCCESS:{
      return Object.assign (
        {},
        state,
        initialState
    )
    }

    case IS_SELECT_ALL_LETTER:{
      return Object.assign (
        {},
        state,
        {isSelectAll:action.payload}
    )
    }

    default:
      return state;
  }
}
